import { Alert, AlertDescription } from "@chakra-ui/react";
import { PreferredReturnSummaryData } from "gen/model/preferredReturnSummaryData";
import { useTranslation } from "react-i18next";
import { RouteLink } from "shared/components/link/RouteLink";
import { rootRoute } from "shared/navigation/Routes";
import { formatIsoDateToDisplay } from "shared/utils/DateUtils";

export const WaterfallMaxPrefBanner: React.FC<{
  summaryData: PreferredReturnSummaryData;
  fundFamilyId: string;
  fundFamilyEventId: string;
  fundEntityId: string;
  investorEntityId?: string;
}> = ({
  summaryData,
  fundFamilyId,
  fundFamilyEventId,
  fundEntityId,
  investorEntityId,
}) => {
  const { t } = useTranslation(["common", "waterfall"]);

  const baseRoute = rootRoute({})
    .fundFamilies({})
    .fundFamily({ fundFamilyId })
    .capitalActivity({})
    .capitalActivityEvent({ fundFamilyEventId })
    .waterfall({})
    .review({
      fundFamilySubEventId:
        summaryData.fund_family_subevent_with_max_preferred_return,
      fundEntityId,
    });

  return (
    <Alert status="info" data-ls-enabled={true} data-public={true} mb="16px">
      <AlertDescription>
        <>
          {t("waterfall:preferredReturnReview.maximumPreferredReturnLink", {
            date: formatIsoDateToDisplay(summaryData.effective_date_of_event),
          })}
          <RouteLink
            display="inline-flex"
            alignItems="center"
            variant="primary"
            padding="0px"
            marginLeft="-4px"
            to={
              investorEntityId
                ? baseRoute
                    .breakdown({ investorEntityId })
                    .investorPreferredReturn({}).$
                : baseRoute.fundPreferredReturn({}).$
            }
          >
            {t("waterfall:preferredReturnReview.previousDistribution", {
              date: formatIsoDateToDisplay(
                summaryData.date_of_max_preferred_return,
              ),
            })}
          </RouteLink>
          .
        </>
      </AlertDescription>
    </Alert>
  );
};
